import { useRecordContext} from 'react-admin';
import Chip from '@mui/material/Chip'
import {LabelValueFromConst} from "Component/Handlers/ValueFromConst";
import React from "react";

const OnDutyField = props => {
    const record = useRecordContext();
    const defaultColors = {true: '#32A232', false: '#d32f2f'};
    const handlColor = props.color || {};
    const handlStyle = props.style || {};

    return (
        <Chip
            style={{...handlStyle,...{color: 'white', background: {...defaultColors, ...handlColor}[record.isOnDuty]}}}
            label={LabelValueFromConst(props.list, record.isOnDuty, '-')}
        />
    );
};

export default OnDutyField;

